import { render, staticRenderFns } from "./Fomatter.vue?vue&type=template&id=54b19510"
import script from "./Fomatter.vue?vue&type=script&lang=js"
export * from "./Fomatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports